"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const API = {
    uploadImage: '/api/file/upload',
    uploadPublicKey: '/api/file/key'
};
class Upload {
    constructor(httpClient) {
        this._httpClient = httpClient;
    }
    async uploadImage(file, fileName) {
        let headers = { 'Content-Type': 'multipart/form-data' };
        if ((file === null || file === void 0 ? void 0 : file.getHeaders) && typeof file.getHeaders === 'function') {
            headers = { ...headers, ...file.getHeaders() };
        }
        const res = await this._httpClient.post(`${API.uploadImage}?filename=${fileName}`, file, {
            headers,
        });
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return data;
        }
        data.result = resBody.filePath;
        return data;
    }
    async uploadPublicKey(file, serviceId) {
        let headers = { 'Content-Type': 'multipart/form-data' };
        if ((file === null || file === void 0 ? void 0 : file.getHeaders) && typeof file.getHeaders === 'function') {
            headers = { ...headers, ...file.getHeaders() };
        }
        const res = await this._httpClient.post(`${API.uploadPublicKey}/${serviceId}`, file, {
            headers,
        });
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return data;
        }
        data.result = resBody;
        return data;
    }
}
exports.default = Upload;
